import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { HistoryEntry } from "./HistoryEntry";

export const HistoryColumnHeader = ({ label }) => {
  return (
    <Typography
      lineHeight={1}
      textTransform="uppercase"
      variant="caption"
      fontWeight={500}
    >
      {label}
    </Typography>
  );
};

export const CommitHistory = ({ commits, onSelectedId }) => {
  const theme = useTheme();
  const [selectedId, setSelectedId] = useState(0);

  const updateSelectedId = useCallback(
    (id) => {
      if (onSelectedId) onSelectedId(id);
      setSelectedId(id);
    },
    [onSelectedId],
  );

  useEffect(() => {
    for (let c of commits) {
      if (c.commitId === selectedId) return;
    }
    updateSelectedId(0);
  }, [commits, selectedId, updateSelectedId]);

  return (
    <>
      <Grid
        container
        display="flex"
        alignItems="center"
        bgcolor={theme.palette.background.paper}
        borderBottom={`1px solid ${theme.palette.grey.main}`}
        borderRadius={1}
        boxShadow={2}
        height={30}
        m={1}
        mb={0}
        p={1}
      >
        <Grid
          display="flex"
          offset={{ xs: 1, lg: 0.5, xl: 0.5 }}
          size={{ xs: 3.5, lg: 3, xl: 2.5 }}
        >
          <HistoryColumnHeader label="Commit Type" />
        </Grid>
        <Grid display="flex" size={{ xs: 3, lg: 3.5, xl: 3 }}>
          <HistoryColumnHeader label="Date Added" />
        </Grid>
        <Grid display="flex" size={{ xs: 2, lg: 2, xl: 2.5 }}>
          <HistoryColumnHeader label="Audio Duration" />
        </Grid>
        <Grid display="flex" size={{ xs: 2.5, lg: 2, xl: 3.5 }}>
          <HistoryColumnHeader label="Annotations" />
        </Grid>
      </Grid>
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <Box display="flex" flexDirection="column" flex={1} p={1}>
          {commits.map((commit, i) => {
            return (
              <HistoryEntry
                key={i}
                commit={commit}
                selectedId={selectedId}
                onSelected={(id) => updateSelectedId(id)}
              />
            );
          })}
        </Box>
      </Box>
    </>
  );
};
